<template>
  <ul>
    <li class="p-the-header-navi-on-general__navi__item">
      <slot name="category"></slot>
    </li>
    <li class="p-the-header-navi-on-general__navi__item">
      <NaviItemLinkForSpOnGeneral url="/favorites/" label="お気に入り">
        <template v-slot:icon>
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            :icon-color="iconColor"
          >
            <IconHeart />
          </IconBase>
        </template>
      </NaviItemLinkForSpOnGeneral>
    </li>
    <li class="p-the-header-navi-on-general__navi__item">
      <NaviItemLinkForSpOnGeneral url="/browser-history/" label="閲覧履歴">
        <template v-slot:icon>
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            :icon-color="iconColor"
          >
            <IconHistoryLog />
          </IconBase>
        </template>
      </NaviItemLinkForSpOnGeneral>
    </li>
  </ul>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconHeart from "@/common/components/icons/IconHeart.vue";
import IconHistoryLog from "@/common/components/icons/IconHistoryLog.vue";
import NaviItemLinkForSpOnGeneral from "@/common/components/organisms/header/general/NaviItemLinkForSpOnGeneral.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props:{
	iconColor: { type: String, required: true }
  },
  components: {
    IconBase,
    IconHeart,
    IconHistoryLog,
    NaviItemLinkForSpOnGeneral
  }
})
export default class TheHeaderNaviOfSubMenu extends Vue {
  iconColor!: string;
}
</script>
